module.exports = "<div id=ng-dro-uaa-on403 class=\"container-fluid animated fadeIn\"> <div class=\"panel panel-default panel-card\"> <div class=panel-heading> <div class=clearfix></div> </div> <div class=panel-body> <br> <div class=row> <div class=\"col-12 text-center\"> <i class=\"fa fa-3x fa-info-circle\"></i> </div> </div> <br> <div class=row> <div class=\"col-12 text-center\"> <h4> <b>{{'uaa.handles-403-loop.title'| translate}}</b> </h4> </div> <div class=\"col-12 text-center\"> <h5> {{'uaa.handles-403-loop.msg'| translate}} </h5> </div> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/on403Loop/on403Loop.html
// module id = 361
// module chunks = 0